import React, { useEffect, useState } from 'react'
import DateComponent from '../components/DateComponent';
import FileViewer from '../components/FileViewer';
import { getDepositDetailsAsync } from '../services/depositService';
import { useParams } from 'react-router-dom';

const DisplayDeposit = () => {
     const { depositId } = useParams();
  const [deposit, setDeposit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (!depositId) {
      setError("رقم الإيداع غير متوفر.");
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchDeposit = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getDepositDetailsAsync(depositId);
        if (cancelled) return;

        const data = response?.result ?? null;
        setDeposit(data);
      } catch (err) {
        if (cancelled) return;
        setError(err?.message || "حدث خطأ أثناء جلب بيانات الإيداع.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchDeposit();
    return () => {
      cancelled = true;
    };
  }, [depositId]);

  if (loading) return <p>جاري التحميل...</p>;
  if (error) return <p className="text-danger">{error}</p>;
  if (!deposit) return <p>لا توجد بيانات لهذا الإيداع.</p>;


  return (
       <div className="container my-4 ">
        {/* Header Section */}
        <div className="mb-4 text-center">
          <h2 className="fw-bold">تفاصيل مراجعة الايداع</h2>
          <p className="fw-bold ">ايداع الموظف : {deposit.empName}</p>
          <p className="text-secondary">
            الرقم المرجعي:{" "}
            <span className="">{deposit.referenceNumber}</span>
          </p>
        </div>

        {/* Deposit Details Section */}
        <div className="mb-4 p-4 rounded shadow ">
          {/* Section Title */}
          <h4 className="fw-bold mb-4 border-bottom pb-2 text-center ">
            تفاصيل الإيداع
          </h4>

          {/* Sequence and Standard Details */}
          <div className="row mb-3">
            <div className="col-12 col-md-6 mb-2">
              <p className="mb-1">
                <span className="fw-bold "> رقم البند: </span>
                <span className="ms-2 ">
                  {deposit.mainStandardSequence} / {deposit.subStandardSequence}{" "}
                  - {deposit.itemSequence}
                </span>
              </p>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <p className="mb-1">
                <span className="fw-bold ">المعيار الرئيسي: </span>
                <span className="ms-2 "> {deposit.mainStandardName} </span>
              </p>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <p className="mb-1">
                <span className="fw-bold ">المعيار الفرعي: </span>
                <span className="ms-2 "> {deposit.subStandardName} </span>
              </p>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <p className="mb-1">
                <span className="fw-bold "> البند: </span>
                <span className="ms-2 ">{deposit.itemName} </span>
              </p>
            </div>
          </div>

          {/* Reference Number and Score */}
          <div className="d-flex justify-content-evenly align-items-center border-top pt-3">
            <div>
              <p className="mb-0">
                <span className="fw-bold ">رقم المرجع: </span>
                <span className="ms-2 ">{deposit.referenceNumber} </span>
              </p>
            </div>
            <div>
              <p className="mb-0 mx-5">
                <span className="fw-bold ">الدرجة: </span>
                <span className="ms-2 dark-color">{deposit.itemScore} </span>
              </p>
            </div>
          </div>

{/* Validation Fields Section */}
<div className="bg-light border rounded p-4 mt-4">
  <h5 className="fw-bold text-center mb-4 text-dark">🧾 حقول التحقق</h5>

  {deposit.validationFields && deposit.validationFields.length > 0 ? (
    <div className="row g-3">
      {deposit.validationFields.map((field) => (
        <div key={field.validationFieldId} className="col-12 col-md-6">
          <div className="p-3 border rounded h-100 bg-white text-end shadow-sm">
            <p className="mb-1 fw-bold text-dark">{field.fieldName}</p>
            {field.fieldDescription && (
              <p className="mb-2 text-muted small">{field.fieldDescription}</p>
            )}

            {field.fieldType === "text" && (
              <div className="form-control border-secondary bg-light text-end">
                {field.fieldValue}
              </div>
            )}

            {field.fieldType === "date" && (
              <div className="form-control border-secondary bg-light text-end">
                <DateComponent date={field.fieldValue} />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  ) : (
    <p className="text-center text-danger fw-bold">لا توجد حقول تحقق.</p>
  )}
</div>

{/* Files Section */}
<div className="bg-light border rounded p-4 mt-4">
  <h5 className="fw-bold text-center mb-4 text-dark">📎 الملفات</h5>

  {deposit.files && deposit.files.length > 0 ? (
    <FileViewer depositData={deposit} />
  ) : (
    <p className="text-center text-danger fw-bold">لم يتم رفع ملفات</p>
  )}
</div>


        </div>

        {/* Audit Section */}
        <div className="mb-4 p-4 rounded shadow-sm ">
          {/* Auditor State Display */}
      <h4>حالة المراجعة :</h4>
<div
  style={{ border: "none" }}
  className={`form-control white-color ${
    deposit.auditorState === "rejected"
      ? "bg-danger"
      : deposit.auditorState === "accepted"
      ? "bg-success"
      : "bg-secondary"
  }`}
>
  {deposit.auditorState === "rejected"
    ? "مرفوض"
    : deposit.auditorState === "accepted"
    ? "مقبول"
    : "قيد المراجعة"}
</div>


         {/* Conditionally Rendered Reject Reason */}
{deposit?.auditorState === "rejected" && (
  <div className="form-group mb-3">
    <label className="text-end mb-2">سبب الرفض :</label>
    <p
      style={{ border: "none" }}
      className={`form-control ${
        (deposit?.auditorRejectReaso || deposit?.auditorRejectReason)
          ? "bg-danger white-color"
          : ""
      }`}
    >
      {deposit?.auditorRejectReaso ||
       deposit?.auditorRejectReason ||
       "لا يوجد سبب للرفض"}
    </p>
  </div>
)}

      {/* Anonymous Notes */}
<div className="form-group mb-3 mt-3">
  {(deposit?.auditorNoteToClient || deposit?.reviewerNoteToClient) ? (
    <>
          <h5 className="mb-2">ملاحظة :</h5>
      {deposit?.auditorNoteToClient && (
        <>
          <p style={{ border: "none" }} className="form-control alert alert-warning">
            {deposit.auditorNoteToClient}
          </p>
        </>
      )}

      {deposit?.reviewerNoteToClient && (
        <>
          <p style={{ border: "none" }} className="form-control alert alert-warning">
            {deposit.reviewerNoteToClient}
          </p>
        </>
      )}
    </>
  ) : (
    <>
      <h5 className="mb-2">ملاحظة :</h5>
      <p style={{ border: "none" }} className="form-control">
        لا توجد ملاحظات
      </p>
    </>
  )}
</div>
        </div>
 
      </div>
  )
}

export default DisplayDeposit
